import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PaginationItem from './PaginationItem';
import moment from 'moment';
import { formatCurrency } from '../../../utils/CurrencyUtils';

export default function ExecutionsWorksTable({
	data,
	dataLoader,
	headers,
	currency,
}) {
	return (
		<>
			<TableContainer component={Paper} style={{ boxShadow: 'none' }}>
				<Table
					sx={{ minWidth: 0, marginBottom: '1em' }}
					size='small'
					aria-label='a dense table'
				>
					<TableHead>
						<TableRow>
							{headers.map((title, key) => {
								return (
									<TableCell key={key} align='center'>
										{title}
									</TableCell>
								);
							})}
						</TableRow>
					</TableHead>
					<TableBody>
						{data.executions.length > 0
							? data.executions.map((row, key) => (
									<TableRow
										key={key}
										sx={{
											'&:last-child td, &:last-child th':
												{ border: 0 },
										}}
									>
										<TableCell key={key} align='center'>
											{moment(row.selling_month).format(
												'MM/YYYY'
											)}
										</TableCell>

										<TableCell key={key} align='center'>
											{row.title}
										</TableCell>
										<TableCell key={key} align='center'>
											{row.performer}
										</TableCell>
										<TableCell key={key} align='center'>
											{row.platform}
										</TableCell>
										<TableCell key={key} align='center'>
											{row.streams}
										</TableCell>
										<TableCell key={key} align='center'>
											{formatCurrency(
												row.total_value,
												currency
											)}
										</TableCell>
										<TableCell key={key} align='center'>
											{row.share + '%'}
										</TableCell>
										<TableCell key={key} align='center'>
											{formatCurrency(
												row.total_client_value,
												currency
											)}
										</TableCell>
										<TableCell key={key} align='center'>
											{formatCurrency(
												row.orb_fee,
												currency
											)}
										</TableCell>
										<TableCell key={key} align='center'>
											{formatCurrency(
												row.client_revenue,
												currency
											)}
										</TableCell>
									</TableRow>
							  ))
							: null}
					</TableBody>
				</Table>
			</TableContainer>
			{dataLoader ? ( // do not show pagination when there is nothing to load after
				<PaginationItem data={data} changePage={dataLoader} />
			) : null}
		</>
	);
}
